export default __webpack_public_path__ + "static/media/Picture5.47a036f4.png";